import React from 'react';
import * as styles from './styles.scss';

const H2 = ({ children, className }) => (
    <h2 className={`${styles.title}${className ? ` ${className}` : ''}`}>
        {children}
    </h2>
);

export default H2;
